<script>
import { mapActions } from 'vuex'

export default {
  name: 'RemoveLimitModal',
  props: {
    id: {
      type: String,
      required: true,
    },
    cashOutOverridable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      progress: false,
    }
  },
  methods: {
    ...mapActions('claims', ['claimCashOutOverride']),
    async onSubmit() {
      this.progress = true

      const [error, request] = await this.claimCashOutOverride({
        id: this.id,
        payload: !this.cashOutOverridable,
      })

      if (!error) {
        this.$emit('done', request)
        this.$emit('close-modal')
      }

      this.progress = false
    },
  },
}
</script>

<template>
  <state-dialog
    title="Remove Cash Out Limit"
    width="380px"
    brand="danger"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <el-icon
      slot="icon"
      name="price-tag"
    />
    <div :class="$style.msg">
      Are you sure you wish to remove the Cash Out limit?<br>
      This member will be able to cash the remaining balance of this claim into their bank account.
    </div>
    <div class="modal__footer">
      <el-button
        type="danger"
        plain
        :loading="progress"
        class="el-button--wide"
        @click.stop="onSubmit"
      >
        Remove Cash Out Limit
      </el-button>
    </div>
  </state-dialog>
</template>

<style lang="scss" module>
.msg {
  word-break: normal;
}
</style>
